import { phoneInputInit } from "Components/form/input/phone";

(($, GLOBAL) => {
  if (!GLOBAL.formFuncs) {
    GLOBAL.formFuncs = {};
  }

  const initRecaptcha = (parentElement) => {
    const container = parentElement.querySelector(".g-recaptcha");

    if (container && window.grecaptcha) {
      const rendered = container.dataset.rendered !== undefined;

      if (!rendered) {
        const id = window.grecaptcha.render(container);
        console.log("~id", ~id);
        if (~id) {
          container.dataset.rendered = `id-${id.toString()}`;
        }
      }
    }
  };

  function setupListeners() {
    const forms = document.querySelectorAll("form");

    forms.forEach((form) => {
      const onSuccessFuncName = form.dataset.onSuccessSendFormFunc;
      if (onSuccessFuncName !== undefined) {
        const func = GLOBAL.formFuncs[onSuccessFuncName];
        if (func && typeof func === "function") {
          form.addEventListener("success", (e) => {
            func(e, e.detail ?? {});
          });
        }
      }

      document.addEventListener("grecaptcha:load", () => {
        form.addEventListener("change", (e) => {
          initRecaptcha(form);
        });
      });
    });
  }

  $(document).ready(function () {
    console.log("document ready");
    phoneInputInit();
  });

  setupListeners();
})(jQuery, window);
